import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import "./audit.scss";
import Loader from "../../components/Loader/Loader";
import LockedIcon from "../../components/Icons/LockedIcon";
import BlurSection from "../../shared/BlurSection/BlurSection";
import { useSelector } from "react-redux";

const PerformanceReportingStatus = ({ auditClientStatus, auditLoading }) => {
  console.log(
    "=====PerformanceReportingStatus",
    auditClientStatus,
    auditLoading
  );
  const { modulesAccess: uploadStatementModule } = useSelector(
      (state) => state.auditUploadStatusReducer
    );
  const years = auditClientStatus?.auditSheetYears || [];
  const reportingStatus = auditClientStatus?.auditSheetStatus;
  return (
    <>
      <Box className="performanceReportingStatusContainer">
        <Box className="heading">Performance Reporting Status</Box>
        <Box style={{ position: "relative" }}>
          {auditLoading ? (
            <>
              <Box height={"300px"}>
                <Loader />
              </Box>
            </>
          ) : years.length > 0 ? (
            <>
              <Box>
                <Flex
                  style={{
                    marginBottom: "5px",
                    gap: "5px",
                    justifyContent: "space-between",
                  }}
                >
                  {years.map((year) => (
                    <Box
                      key={year}
                      className={`year-list ${
                        year === "2025"
                          ? "bg-white text-gray-600"
                          : "bg-gray-600 text-white"
                      }`}
                    >
                      {year}
                    </Box>
                  ))}
                </Flex>

                <Box className="space-y-4">
                  <Box>
                    <Flex
                      style={{
                        marginBottom: "5px",
                        gap: "5px",
                        justifyContent: "space-between",
                      }}
                    >
                      {years.map((year) => (
                        <Box key={`bs-${year}`} className="year-checklist">
                          {reportingStatus.balanceSheet[year] &&
                          reportingStatus.profitLoss[year] ? (
                            <LockedIcon />
                          ) : (
                            <></>
                          )}
                        </Box>
                      ))}
                    </Flex>
                  </Box>
                  <Box>
                    <Box
                      style={{
                        backgroundColor: "#F8F8F8",
                        textAlign: "center",
                      }}
                    >
                      Balance Sheet
                    </Box>
                    <Flex
                      style={{
                        marginBottom: "5px",
                        gap: "5px",
                        justifyContent: "space-between",
                      }}
                    >
                      {years.map((year) => (
                        <Box key={`bs-${year}`} className="year-checklist">
                          {reportingStatus.balanceSheet[year] === true ||
                          reportingStatus.balanceSheet[year] === false
                            ? "✓"
                            : "−"}
                        </Box>
                      ))}
                    </Flex>
                  </Box>

                  <Box>
                    <Box
                      style={{
                        backgroundColor: "#F8F8F8",
                        textAlign: "center",
                      }}
                    >
                      Profit & Loss Sheet
                    </Box>
                    <Flex
                      style={{
                        marginBottom: "5px",
                        gap: "5px",
                        justifyContent: "space-between",
                      }}
                    >
                      {years.map((year) => (
                        <Box key={`pl-${year}`} className="year-checklist">
                          {reportingStatus.profitLoss[year] === true ||
                          reportingStatus.profitLoss[year] === false
                            ? "✓"
                            : "−"}
                        </Box>
                      ))}
                    </Flex>
                  </Box>
                </Box>
              </Box>
            </>
          ) : (
            <>
              <Box style={{ backgroundColor: "#F8F8F8", textAlign: "center" }}>
                No data found
              </Box>
            </>
          )}
          {uploadStatementModule &&
            uploadStatementModule?.["Performance Reporting Status"] &&
            uploadStatementModule["Performance Reporting Status"]?.["showBlur"] && (
              <BlurSection height={"100%"} width={"100%"} />
            )}
        </Box>
      </Box>
    </>
  );
};

export default PerformanceReportingStatus;
